var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarn = function SvgBarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M20.25 10.55v12.7H3.75v-12.7"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M11.113 1.4 1.056 8.775a.75.75 0 0 0-.306.605v1.89a.751.751 0 0 0 1.194.605L12 4.5l10.056 7.375a.751.751 0 0 0 1.194-.605V9.38a.75.75 0 0 0-.306-.605L12.887 1.4a1.5 1.5 0 0 0-1.774 0M.75 23.25h22.5m-6-9H6.75v9h10.5zm-10.5 0 10.5 9m0-9-10.5 9"
  })), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M12 10.125a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
  }))));
};
export default SvgBarn;